const React = require('react-native');

const { StyleSheet, Platform, Dimensions } = React;

const deviceHeight = Dimensions.get('window').height;
const deviceWidth = Dimensions.get('window').width;

export default {
	sidebar: {
		flex: 1,
		backgroundColor: '#fff'
	},
	drawerCover: {
		alignSelf: 'stretch',
		// resizeMode: 'cover',
		height: deviceHeight / 3.5,
		//width: 200,
		position: 'relative',
		marginBottom: 5,
		marginTop: -10,
		justifyContent: 'space-around',
		paddingRight: 5
	},
	drawerImage: {
		width: 210,
		height: 75,
		resizeMode: 'cover',
		alignSelf: 'center'
	},
	listItemContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	iconContainer: {
		width: 37,
		height: 37,
		borderRadius: 18,
		marginRight: 12,
		paddingTop: Platform.OS === 'android' ? 7 : 5
	},
	sidebarIcon: {
		fontSize: 21,
		color: '#fff',
		lineHeight: Platform.OS === 'android' ? 21 : 25,
		backgroundColor: 'transparent',
		alignSelf: 'center'
	},
	inactiveIcon: {
		/*
		 * Icons have 0.54 opacity according to guidelines
		 * 100/87 * 54 ~= 62
		 */
		opacity: 0.62,
		color: '#555'
	},
	icon: { color: '#438eb9', fontSize: 26, width: 30 },
	text: {
		fontWeight: Platform.OS === 'ios' ? '500' : '400',
		fontSize: 16,
		marginLeft: 20
	},
	badgeText: {
		fontSize: Platform.OS === 'ios' ? 13 : 11,
		fontWeight: '400',
		textAlign: 'center',
		marginTop: Platform.OS === 'android' ? -3 : undefined
	}
};
